import * as React from 'react';

export function formatCurrency(value, negativeParentheses = false) {
  if (value >= 0) {
    return '$' + parseFloat(value).toFixed(2);
  } else if (negativeParentheses == false) {
    return '-$' + Math.abs(parseFloat(value)).toFixed(2);
  } else {
    return '($' + Math.abs(parseFloat(value)).toFixed(2) + ')';
  }
}

export const Currency = (props) =>
  <span>{formatCurrency(props.value)}</span>